module.exports = __webpack_public_path__ + "img/northstar-7.2ce1608a.jpg";